// export const Url = "http://localhost:8080" 
export const Url = "https://www.gig-big.in" 
// export const Url = "https://teamlans.in" 
// export const Url = "https://rude-dolls-wonder.loca.lt" 


